export default __webpack_public_path__ + "static/media/marker-sky-yellow.9ff408f9.png";